export const alertsForUser = {
    state: {
        status: 'idle',
        alertsForUser: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {}
    },
    mutations: {
        SET_ALERTSFORUSER_STATUS(state, status) {
            state.status = status
        },
        SET_ALERTSFORUSER(state, alertsForUser) {
            state.alertsForUser = alertsForUser
        },
        SET_ALERTSFORUSER_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        SET_ALERTSFORUSER_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_ALERTSFORUSER_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchAlertsForUser({ state, commit, dispatch, getters }) {
            commit('SET_ALERTSFORUSER', [])
            commit('SET_ALERTSFORUSER_STATUS', 'loading')
            return dispatch('resetAlertsForUserPagination').then(() => {
                return this.$api.get(`api/alerts/notifications.json?${getters.alertsForUserQueryString}`).then((response) => {
                    commit('SET_ALERTSFORUSER', response.data.data)
                    commit('SET_ALERTSFORUSER_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.alertsForUser.length : response.data.data.length === 0)
                    commit('SET_ALERTSFORUSER_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_ALERTSFORUSER_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchAlertsForUserNextPage({ state, commit, getters }) {
            if(state.areAllFetched) {
                return false
            }
            commit('SET_ALERTSFORUSER_STATUS', 'loadingMore')
            commit('SET_ALERTSFORUSER_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/alerts/notifications.json?${getters.alertsForUserQueryString}`).then((response) => {
                commit('SET_ALERTSFORUSER', state.alertsForUser.concat(...response.data.data))
                commit('SET_ALERTSFORUSER_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.alertsForUser.length : response.data.data.length === 0)
                commit('SET_ALERTSFORUSER_STATUS', 'idle')
            }).catch(error => {
                commit('SET_ALERTSFORUSER_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        setAlertsForUserSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if(Object.prototype.hasOwnProperty.call(payload, 'name') &&
               Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_ALERTSFORUSER_QUERY', payload)
            } else {
                console.error('Invalid payload')
            }
        },
        resetAlertsForUserQuery({ commit, dispatch }) {
            commit('SET_ALERTSFORUSER_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'alertsForUser',
                object: 'query'
            })
        },
        resetAlertsForUserPagination({ commit, dispatch }) {
            commit('SET_ALERTSFORUSER_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'alertsForUser',
                object: 'pagination'
            })
        }
    },
    getters: {
        alertsForUserStatus: (state) => {
            return state.status
        },
        alertsForUser: (state) => {
            if(state.alertsForUser) {
                return state.alertsForUser
            }
        },
        alertsForUserQuery: (state) => {
            return state.query
        },
        alertsForUserQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
